import type React from 'react';
import { getSelectOptions } from '@components/shared';
import { useDatapointsStore } from '@ContractBuilder/store/datapoints.store';
import { datapointFieldSelector } from '@ContractBuilder/utils/datapoint-field-selector';

import type { JSONSchemaEnum, JSONSchemaProperties } from '../../../@types/types';
import type { InputSelectProps } from '../InputSelect';
import InputSelect from '../InputSelect';

export interface InputSelectSchemaProps extends InputSelectProps {
  item: {
    helperText?: string;
    shortName?: string;
    enum: JSONSchemaEnum[];
    oneOf?: JSONSchemaProperties[];
  };
  ownKey: string;
}

const InputSelectSchema: React.FC<InputSelectSchemaProps> = ({ item, ...props }) => {
  'use memo';

  const { ownKey, errors, isRequired } = props;
  const selector = datapointFieldSelector({ ownKey, isRequired, errors });
  const { value, isIncomplete } = useDatapointsStore(selector);

  return (
    <InputSelect
      {...props}
      isIncomplete={isIncomplete}
      helperText={item?.helperText}
      shortName={item?.shortName}
      options={getSelectOptions(item as JSONSchemaProperties)}
      value={value}
      dataTestId={props['data-testid']}
    />
  );
};

export default InputSelectSchema;
